import styled from "styled-components";
import { css } from "styled-components";
import React from "react";
import tw from "twin.macro";
export const StyledButton = styled.button`
  ${tw`text-center py-3 rounded-md w-full bg-red-600 hover:bg-red-500 font-medium`}
`;

export const Container = styled.div`
  margin-left: auto;
  margin-right: auto;
  max-width: 1170px;

  ${(props) =>
    props.wrapper &&
    css`
      @media (min-width: 700px) {
        display: grid;
        grid-template-columns: 1fr 2fr;
        > * {
          padding: 2em;
        }
      }
    `}
`;

export const Form = styled.form`
  ${tw`grid md:grid-cols-2 gap-5`}
`;

export const Input = styled.input`
  ${tw`focus:outline-none rounded-md text-black  focus:(ring ring-red-500) w-full px-2 py-3`}
`;

export const Select = styled.select`
  ${tw`focus:outline-none rounded-md text-black  focus:(ring ring-red-500) w-full px-2 py-3`}
`;

export const Label = styled.label`
  display: block;

  ${tw`font-medium my-1`}
`;

export const Textarea = styled.textarea`
  ${tw`focus:outline-none rounded-md  text-black focus:(ring ring-red-500) w-full px-2 py-3`}
`;

const Title = ({ className, text }) => <h1 className={className}>{text}</h1>;

export const StyledTitle = styled(Title)`
  color: #b8161f;
  font: 70px;
  text-align: center;
  @media (min-width: 700px) {
    text-align: left;
  }
`;
